var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 483,
    viewBox: "0 0 513 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_131_1598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.535 97.696L491.78 97.5847C419.563 79.4512 329.314 42.3766 257.099 24.2425C251.998 22.9622 246.897 21.6812 241.795 20.4C240.136 21.1495 239.398 21.515 238.078 22.4567C237.917 22.5525 237.768 22.6437 237.625 22.7325L237.521 22.7986L237.221 22.9927L237.101 23.0739L236.829 23.2626L236.728 23.3347C236.489 23.5088 236.255 23.6905 236.008 23.8903L235.891 23.9876L235.616 24.2165L235.475 24.3359C235.379 24.4179 235.279 24.5037 235.176 24.5932L235.03 24.7187C234.882 24.8471 234.726 24.982 234.558 25.1294C234.68 25.1598 234.814 25.1932 234.938 25.2252C211.533 45.6779 206.343 96.9346 201.323 146.664C197.436 185.162 190.888 250.023 178.869 302.816C150.984 295.813 123.099 288.81 95.2115 281.808C75.6315 278.586 66.8496 312.751 59.7934 340.203C45.7408 394.874 29.0802 403.526 20.4 403.817C97.7178 423.232 175.025 442.645 252.342 462.061C263.715 461.301 275.75 366.842 284.632 344.103C284.632 344.103 305.919 383.255 345.128 389.409C384.338 395.563 414.255 345.486 419.644 310.522C425.062 275.115 445.891 207.801 446.669 200.733C450.919 187.524 457.208 170.858 460.083 156.917C463.173 141.942 470.458 114.935 484.542 102.316C487.755 99.8302 488.703 99.0967 490.114 98.3724C490.314 98.2695 490.527 98.1653 490.753 98.059C490.991 97.9452 491.251 97.8254 491.535 97.696Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_131_1598",
    x: 0.000391006,
    y: -0.0000972748,
    width: 512.181,
    height: 482.461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.2,
    result: "effect1_foregroundBlur_131_1598"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow);
export default __webpack_public_path__ + "static/media/Shadow.554ce3042dd1474ed53da2725a93f86f.svg";
export { ForwardRef as ReactComponent };